<template>
<div>
    <div class="pgemnt-1">
        <div class="tbs">
            <el-table :data="postList" v-loading="false" style="width: 100%" border>
                <el-table-column label="角色名称" prop="name"> </el-table-column>
                <el-table-column label="所属机构" prop="organizationName" width="145">
                </el-table-column>
                <el-table-column label="状态" width="90">
                    <template slot-scope="scope">
                        {{ scope.row.status | filterStatus() }}
                    </template>
                </el-table-column>
                <el-table-column align="left" width="240" label="操作">
                    <template slot-scope="scope">
                        <el-button type="warning" @click="goEdit(scope.row)" size="mini">编辑</el-button>
                        <el-button type="danger" @click="deleteDTO(scope.row.id)" size="mini">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</div>
</template>

<script>
import {
    getAllList,
    deleteManagePostDTO,
} from '@/api/pgMent/roleMent';
export default {
    components: {},
    data() {
        return {
            loading: false,
            postList: [],
            params: {
                name: '',
                basePage: {
                    size: 12, // 分页大小
                    no: 1, // 当前分页
                }
            }
        }
    },
    filters: {
        filterStatus: function (e) {
            var transMap = {
                0: '未知',
                1: '停用',
                2: '启用',
            };
            return transMap[e];
        }
    },
    methods: {
        // 获取文章列表
        getList() {
            var vues = this;
            this.loading = true;
            getAllList(this.params).then(res => {
                this.postList = res.postList
                console.log(res);
                console.log(res.postList);
                vues.loading = false;
                // vues.showArr = res.cmsColumnLists;
                // console.log(vues.showArr);
            })
        },
        // 删除文章列表
        deleteDTO(id) {
            var param = {
                id: id
            }
            deleteManagePostDTO(param).then(res => {
                this.$message.success('操作成功!')
                this.getList()
            }).catch(err => {
                console.log(err);
            })
        },
        // 编辑 
        goEdit: function (e) { // 编辑
            var querys = {};
            querys.id = e.id;
            this.$router.push({
                path: 'rule_column_add',
                query: querys
            });
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        },
    },
    created: function () {
        this.getList()
    }
}
</script>

<style lang="scss">
.pgemnt-1 {
    padding: 20px;
}

.pgemnt-1-dag table {
    width: 100%;
    margin-top: 12px;
}

.pgemnt-1 .newAdd {
    width: 90px;
}

// 头部样式
.tbs th {
    background-color: #efefef;
}

// .el-input__suffix {
//   right: 0px;
//   transition: all 0.3s;
// }
</style>



// WEBPACK FOOTER //
// ruleList.vue?d5990504